export default __webpack_public_path__ + "images/pf-296e94595f307817fc2bf28cc6a98618.svg";